import { selector } from 'recoil';
import type { FormBuilder_Style_ThemeFragment } from '~/graphql/types';
import isRecoilDefaultValue from '~/typeguards/isRecoilDefaultValue';
import { formState } from '.';

const defaultThemeState: FormBuilder_Style_ThemeFragment = {
  __typename: 'FormBuilder_Style_Theme',
  colors: {
    __typename: 'WidgetSettingsStyles',
    primary: {
      __typename: 'WidgetSettingsStyleConfigColorPair',
      color: '#fff',
      background: '#fff',
    },
    secondary: {
      __typename: 'WidgetSettingsStyleConfigColorPair',
      background: '#fff',
      color: '#fff',
    },
  },
};

export const themeState = selector<FormBuilder_Style_ThemeFragment>({
  key: 'formBuilder/themeState',
  get: ({ get }) => {
    const form = get(formState);

    return form?.style.theme ?? defaultThemeState;
  },

  set: ({ get, set }, theme) => {
    if (isRecoilDefaultValue(theme)) return;

    const prevForm = get(formState);
    if (!prevForm) return;

    set(formState, {
      ...prevForm,
      style: {
        ...prevForm.style,
        theme: {
          ...prevForm.style.theme,
          ...theme,
        },
      },
    });
  },
});
